import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button, Col, Row, ControlLabel } from 'react-bootstrap';
import { Input, Checkbox, HtmlEditor, FormActions, FormFileUpload, MultiSelect } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import Localizations from '../localization';
import CentersDropdownList from '../centers/DropdownList';

class SettingsForm extends Component {

	constructor(props) {
		super(props);
	}

	render() {
		const { error, handleSubmit, isReadonly, pristine, submitting, submitSucceeded, t, initialValues, lang,
			grades, mixed, isRestrictedUser, enableTrials, enableMakeUps } = this.props;

		const pictureData = initialValues && {
			url: initialValues.pictureUrl
		};
		let id = initialValues ? initialValues.id : 0;

		return (
			<Form horizontal onSubmit={handleSubmit}>
				{error && <Alert bsStyle='danger'>{error}</Alert>}
				{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
				<Field name='name' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Grade_Name')} validate={validators.required} />
				{id > 0 && <Localizations entityId={id} rootName={'grades'} propertyName={'Name'} label={t('Grade_Name')} resourceName={`Grade.${id}.Name`} isHtml={false} isReadonly={isReadonly} />}
				<Field name='slug' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Grade_Slug')} validate={validators.required} />
				<Field name='subName' component={Input} disabled={isReadonly} horizontal type='text' label={t('Grade_SubName')} />
				<CentersDropdownList render='field' name='centerId' disabled={isReadonly} horizontal label={t('Common_Center')} emptyLabel={isRestrictedUser ? '' : t('Common_AllCenters')} />
				<Row>
					<Col componentClass={ControlLabel} sm={2}>
						{t('Grade_FromAge')}
					</Col>
					<Col sm={5}>
						<Field name='fromAgeYears' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Grade_Years')} validate={[validators.required, validators.number]} />
					</Col>
					<Col sm={5}>
						<Field name='fromAgeMonths' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Grade_Months')} validate={[validators.required, validators.number]} />
					</Col>
				</Row>
				<Row>
					<Col componentClass={ControlLabel} sm={2}>
						{t('Grade_ToAge')}
					</Col>
					<Col sm={5}>
						<Field name='toAgeYears' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Grade_Years')} validate={[validators.required, validators.number]} />
					</Col>
					<Col sm={5}>
						<Field name='toAgeMonths' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Grade_Months')} validate={[validators.required, validators.number]} />
					</Col>
				</Row>
				<Field name='maxChildren' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Grade_MaxChildren')} validate={[validators.required, validators.number]} />
				{enableTrials && <Field name='maxTrialChildren' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Grade_MaxTrialChildren')} validate={[validators.required, validators.number]} />}
				{enableMakeUps && <Field name='maxMakeUpChildren' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Grade_MaxMakeUpChildren')} validate={[validators.required, validators.number]} />}
				<Field name='isOnline' component={Checkbox} disabled={isReadonly} horizontal label={t('Grade_IsOnline')} normalize={(v) => { return !!v }} />
				<Field name='mixed' component={Checkbox} disabled={isReadonly} label={t('Grade_Mixed')} horizontal normalize={(v) => { return !!v }} />
				{mixed && <Field name='subGrades' horizontal required component={MultiSelect} options={grades} valueField='id' textField='name' label={t('Grade_SubGrades')} validate={[validators.requiredArray]} />}
				<Field name='pictureId' component={FormFileUpload} image disabled={isReadonly} horizontal label={t('Grade_Image')} initialData={pictureData} />
				<Field name='description' component={HtmlEditor} disabled={isReadonly} lang={lang} horizontal type='text' label={t('Grade_Description')} />
				{id > 0 && <Localizations entityId={id} rootName={'grades'} propertyName={'Description'} label={t('Grade_Description')} resourceName={`Grade.${id}.Description`} isHtml={true} isReadonly={isReadonly} />}
				<Field name='neurologicalIndicator' component={HtmlEditor} disabled={isReadonly} horizontal type='text' label={t('Grade_NeurologicalIndicator')} />
				{id > 0 && <Localizations entityId={id} rootName={'grades'} propertyName={'NeurologicalIndicator'} label={t('Grade_NeurologicalIndicator')} resourceName={`Grade.${id}.NeurologicalIndicator`} isHtml={true} isReadonly={isReadonly} />}
				<FormActions horizontal>
					<Link to='/grades' className='btn btn-default'>{t('Common_BackToList')}</Link>
					<Button type='submit' disabled={isReadonly || pristine || submitting} bsStyle='primary'>{t('Common_Save')}</Button>
				</FormActions>
			</Form>
		);
	};
}

export default reduxForm({ form: 'grade', enableReinitialize: true })(withTranslation()(SettingsForm));
